import TextInput from "~/components/objectModelEntry/object-model-entry-text-input.vue";
import PickListInput from "~/components/objectModelEntry/object-model-entry-pick-list-input.vue";
import DatePickerInput from "~/components/objectModelEntry/object-model-entry-date-picker-input.vue";
import FileInput from "~/components/objectModelEntry/object-model-entry-file-input.vue";
import ObjectModelEntryFieldDefinition from "../../../formability/manageObjectModelEntry/models/objectModelEntryFieldDefinition";
import {ObjectModelPropertyRootType} from "~/enums/objectModelPropertyType";
import {InputFormatType} from "../../../formability/form_builder/models/inputFormatType";
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import Guid from "~/helpers/guid"

export default {
  components: {
    'text-input': TextInput,
    'pick-list-input': PickListInput,
    'date-picker-input': DatePickerInput,
    'file-input': FileInput,
  },
  methods: {
    getComponentForPropertyType(property_type: ObjectModelPropertyRootType) {
      return ObjectModelEntryFieldDefinition.getComponent(property_type);
    },
    getObjectModelPropertyFormatType(format_type: InputFormatType ): string {
      switch (format_type) {
        case InputFormatType.Email:
          return 'email';
        case InputFormatType.Phone:
          return 'tel';
        case InputFormatType.Url:
          return 'url';
        case InputFormatType.None:
        case InputFormatType.Alphanumeric:
        case InputFormatType.Pattern:
        case InputFormatType.SocialSecurity:
        case InputFormatType.Zip:
        default:
          return 'text';
      }
    },
    getAdditionalAttrs(property: ObjectModelProperty): object {
      const {character_count, min_value, max_value, decimal_places} = property;
      switch (property.property_type) {
        case ObjectModelPropertyRootType.Text:
        case ObjectModelPropertyRootType.LongText:
          return {
            type: this.getObjectModelPropertyFormatType(property.format_type),
            minlength: character_count.min,
            maxlength: character_count.max,
            'data-char-limit-message': character_count.char_limit_message,
            'data-show-char-limit': character_count.show_char_limit,
            isMultiline: true
          };
        case ObjectModelPropertyRootType.Number:
          return {
            type: 'number',
            min: min_value,
            max: max_value,
            'data-decimal-places': decimal_places,
          };
        case ObjectModelPropertyRootType.FileAttachment:
          return {
            dropzoneId: `f_${property.client_id}-dropzone_${Guid.create()}`,
          }
      }
    },


  }
}